<template>
  <div class="item">
    <div class="font-bold" v-if="label">
      {{ label }}
    </div>
    <div>{{ value || '-' }}</div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue';

export default {
  name: 'BooleanGroupField',
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: String
  },
  emits: ['update:modelValue'],
  setup(props) {
    const value = ref('');
    onMounted(() => {
      watch(
        () => props.modelValue,
        () => {
          if (props.modelValue && props.options.length) {
            props.options.forEach((option) => {
              if (option.value === props.modelValue) {
                value.value = option.label;
              }
            });
          }
        },
        {
          immediate: true
        }
      );
    });

    return {
      value
    };
  }
};
</script>
